import { Capacitor } from '@capacitor/core';

const isMobile =
  Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
export const authRole = {
  Admin: ['admin', 'user'],
  User: ['user'],
};
export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const allowMultiLanguage = process.env.NX_MULTILINGUAL === 'true';
export const fileStackKey = process.env.NX_FILESTACK_KEY;
export const backendUrl = '/';
export const initialUrl = isMobile
  ? process.env.NX_INITIAL_MOBILE_URL
  : process.env.NX_INITIAL_URL;
